import { render, staticRenderFns } from "./from-inquiry.vue?vue&type=template&id=1d28121a&scoped=true&"
import script from "./from-inquiry.vue?vue&type=script&lang=js&"
export * from "./from-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./from-inquiry.vue?vue&type=style&index=0&id=1d28121a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d28121a",
  null
  
)

export default component.exports